export function formatTwoDecimals(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return value;
  }

  return Number(value).toFixed(2);
}